import {defineMessage} from 'react-intl';

import {cancel} from '@sail/icons/react/Icon';

import {
  HeaderButton,
  type Placement,
  useAnalytics,
} from '@stripe-internal/conversations-ui';

const label = defineMessage({
  id: 'conversations_ui.widget.header.closeButton.label',
  description: 'Label used for the header button that closes the widget.',
  defaultMessage: 'Close',
});

type Props = {
  visibility: 'open' | 'closed' | 'minimized';
  onClose: () => void;
  disabled?: boolean;
  tooltipEnabled?: boolean;
  color?: string;
  hoverColor?: string;
};

export function DotComCloseButton({
  visibility,
  onClose,
  disabled = false,
  tooltipEnabled = true,
  color,
  hoverColor,
}: Props) {
  const analytics = useAnalytics();
  const tooltipPlacement: Placement =
    visibility === 'open' ? 'bottom left' : 'left';

  return (
    <HeaderButton
      testId="conversations-widget-header-close-button"
      icon={cancel}
      label={label}
      onPress={() => {
        if (disabled) {
          return;
        }

        analytics.action('close_button_clicked');
        onClose();
      }}
      tooltipPlacement={tooltipPlacement}
      disabled={disabled}
      color={color}
      hoverColor={hoverColor}
      tooltipEnabled={tooltipEnabled}
    />
  );
}
